var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":_vm.status.status,"title":_vm.status.title},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{key:"back",attrs:{"type":"primary"},on:{"click":_vm.onQuit}},[_vm._v(" 返回 ")])]},proxy:true},{key:"sub-title",fn:function(){return [_vm._v(" 请到历史交易明细确认记账详情 ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }